<template>
  <div class="fossil-details">
    <div class="fossil-title" v-html="fossilInfo.f_specimen_number">
      <!--  -->
    </div>
    <div class="fossil-details-info">
      <div class="fossil-general-info">
        <!-- <div class="cover-img">
          <el-image v-if="fossilInfo.f_cover_img" class="image" :src="defaultImgHeader+fossilInfo.f_cover_img" fit="fill" :preview-src-list="[defaultImgHeader+fossilInfo.f_cover_img]">
            <div slot="error" class="image-slot">
              No Image<span class="dot">...</span>
            </div>
          </el-image>
        </div> -->
        <div class="fossil-general-map">
          <v-map :mapData="markers"></v-map>
        </div>
        <!-- <div class="fossil-general-images">
          <ul>
            <li v-for="img in fossilImgList">
              <el-image class="image" :src="defaultImgHeader + img.fossil_img_path" fit="fill" :preview-src-list="[defaultImgHeader+img.fossil_img_path]">
                <div slot="error" class="image-slot">
                  No Image<span class="dot">...</span>
                </div>
              </el-image>
            </li>
          </ul>
        </div> -->
      </div>
      <div class="fossil-related-specimens">
        <h3 class="general-info-title">General Info</h3>
        <div class="general-info-container">
          <dl>
            <dt>Classification unit</dt>
            <dd>
              <a v-for="(species,index) in speciesPath" :key="species.s_id">
                <i :class="{'italic':species.s_italic}">{{innerHTML(species.s_en_name)}}</i> <b v-if="index != speciesPath.length-1">></b>
              </a>
            </dd>
          </dl>
          <dl>
            <dt>Specimen ID</dt>
            <dd v-html="fossilInfo.f_specimen_number"></dd>
          </dl>
          <dl>
            <!-- <dt>Fossil/rock/mineral</dt> -->
            <dt>Custodian institute</dt>
            <dd v-html="fossilInfo.f_storage_institute"></dd>
          </dl>
          <dl>
            <dt>Locality</dt>
            <dd v-html="fossilInfo.f_site_country"></dd>
          </dl>
          <dl>
            <dt>Stratigraphy</dt>
            <dd v-html="fossilInfo.f_remarks"></dd>
          </dl>
          <dl>
            <dt>Institution</dt>
            <dd v-html="fossilInfo.f_storage_country"></dd>
          </dl>
          <dl>
            <dt>Latitude scope</dt>
            <dd v-html="fossilInfo.f_site_latitude"></dd>
          </dl>
          <dl>
            <dt>Longitude scope</dt>
            <dd v-html="fossilInfo.f_site_longtitude"></dd>
          </dl>
          <dl>
            <dt>System</dt>
            <dd v-html="fossilInfo.f_chronostratigraphy_system"></dd>
          </dl>
          <dl>
            <dt>Series</dt>
            <dd v-html="fossilInfo.f_chronostratigraphy_series"></dd>
          </dl>
          <dl>
            <dt>Stage</dt>
            <dd v-html="fossilInfo.f_chronostratigraphy_stage"></dd>
          </dl>
          <dl>
            <dt>Group</dt>
            <dd v-html="fossilInfo.f_lithostratigraphy_group"></dd>
          </dl>
          <dl>
            <dt>Formation</dt>
            <dd v-html="fossilInfo.f_lithostratigraphy_formation"></dd>
          </dl>
          <dl>
            <dt>Member</dt>
            <dd v-html="fossilInfo.f_lithostratigraphy_member"></dd>
          </dl>
          <dl>
            <dt>Bed</dt>
            <dd v-html="fossilInfo.f_lithostratigraphy_bed"></dd>
          </dl>
          <dl>
            <dt>Related literature</dt>
            <!-- <dd v-html="fossilInfo.f_lithostratigraphy_literature"></dd> -->
            <dd>
              <ul class="literature-ul">
                <li v-for="item in relatedLiteratureList" :key="item.r_id">
                  <span class="list-type"></span>
                  <router-link :to="'/literature_details/'+item.r_id">{{innerHTML(item.literature.r_author)}},{{innerHTML(item.literature.r_joint_author)}},{{innerHTML(item.literature.r_year)}}</router-link> {{ innerHTML(item.literature.r_title)}},{{ innerHTML(item.literature.r_journal)}},{{ innerHTML(item.literature.r_volume)}},{{ innerHTML(item.literature.r_pages)}} <router-link :to="'https://doi.org/'+item.literature.r_doi" target="_blank">{{item.literature.r_doi}}</router-link>
                </li>
              </ul>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFossilDetails } from "@/api/index";
import VMap from "@/components/map.vue";
import { deepBoneDomin, ossImage } from "@/common.js";
import { mixins } from "@/mixins/index.js";
export default {
  mixins: [mixins],
  components: {
    VMap,
  },
  data() {
    return {
      defaultImgHeader: deepBoneDomin,
      ossImage: ossImage,
      fossilInfo: {
        admin_en_name: "Pan Zhaohui",
        admin_id: 2,
        admin_name: "潘照晖",
        brief_description: "",
        error_s_id: 13,
        f_benthic: "",
        f_chronostratigraphy_series: "Lower",
        f_chronostratigraphy_stage: "Pragian",
        f_chronostratigraphy_subdivision: "",
        f_chronostratigraphy_system: "Devonian",
        f_cover_img: "fossil/11/20180505172403_2_626.png",
        f_cover_img_bk: "reference/4/20180505172403_2_626.png",
        f_last_edit_time: "2021-05-04 15:26:42",
        f_literature_num: 1,
        f_lithostratigraphy_bed: "",
        f_lithostratigraphy_formation: "Danlin",
        f_lithostratigraphy_group: "",
        f_lithostratigraphy_member: "",
        f_path: "0-63836-2-3-3291-6-9-12-",
        f_plate_id: "",
        f_remarks: "<p>Only an AMD preserved.</p>",
        f_site_country: "China",
        f_site_description: "",
        f_site_latitude: "26.25",
        f_site_longtitude: "107.55",
        f_site_place: "Houer mountain, Guizhou",
        f_specimen_number: "vc110121.32",
        f_storage_country: "China",
        f_storage_institute: "The Geogical Museum of China",
        f_tectonic_block: "",
        f_time: "2017-12-11 21:33:16",
        measurement: "",
        f_lithostratigraphy_literature: "",
      },
      fossilImgList: [],
      speciesPath: [],
      relatedLiteratureList: [],
      markers: [],
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    console.log(this.$route.params.fossil_id);
    let fossil_id = this.$route.params.fossil_id;
    this.getFossilDetails(fossil_id);
  },
  methods: {
    getFossilDetails(fossil_id) {
      getFossilDetails(fossil_id).then((res) => {
        let data = res.data?.data;
        let get_one = data?.get_one;
        for (let key in this.fossilInfo) {
          this.fossilInfo[key] = get_one[key];
        }
        this.initFossilImg(data["fossil_img_list"]);
        this.initLiterature(data["literature_list"]);
        this.initSpeciesPath(
          get_one["s_id"],
          get_one["f_path"],
          get_one["species_path"]
        );
        this.initMarkers();
      });
    },
    initFossilImg(imgList) {
      imgList = imgList ? imgList : [];
      this.$set(this, "fossilImgList", imgList);
    },
    initLiterature(literature_list) {
      this.$set(this, "relatedLiteratureList", literature_list);
    },
    initSpeciesPath(self_path, f_path, speciesPath) {
      let paths = f_path.split("-");
      let _speciesPath = [];
      paths.forEach((path) => {
        let species = speciesPath.filter((el) => el.s_id == path);
        if (species.length) {
          _speciesPath.push(species[0]);
        }
      });
      let self_species = speciesPath.filter((el) => el.s_id == self_path);
      if (self_species.length) {
        _speciesPath.push(self_species[0]);
      }

      this.$set(this, "speciesPath", _speciesPath);
    },
    initMarkers() {
      this.markers = [
        {
          centerPoints: [
            this.fossilInfo.f_site_latitude, //纬度
            this.fossilInfo.f_site_longtitude, //经度
          ],
        },
      ];
    },
  },
};
</script>
<style >
.fossil-title {
  height: 143px;
  background: linear-gradient(90deg, #189ca9 9.4%, #72c2c9 93.4%);
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 130px;
  color: #ffffff;
  padding-left: 48px;
}
.fossil-details-info {
  display: flex;
  justify-content: space-around;
  align-content: center;
  width: 100%;
  padding: 32px 48px 60px;
  overflow: hidden;
}
.fossil-general-info {
  width: 34%;
  max-width: 455px;
  margin-right: 2%;
}
.cover-img {
  width: 100%;
}
.fossil-related-specimens {
  width: 64%;
  background: #ffffff;
  border-radius: 4px;
  padding: 20px;
}
.fossil-general-map {
  width: 100%;
  height: 306px;
}
.general-info-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #484d63;
  margin-bottom: 32px;
}
.general-info-container dl {
  line-height: 20px;
  padding: 12px 0;
  border-bottom: 2px solid #efefef;
  color: #484d63;
}
.general-info-container dl dt {
  width: 213px;
}
.general-info-container dd {
  display: inline-block;
  width: calc(100% - 213px);
}
.general-info-container dd a {
  color: #484d63;
}
.general-info-container dd .literature-ul a {
  color: #72c2c9;
}
.literature-ul li {
  padding-left: 18px;
  position: relative;
  line-height: 24px;
  margin-bottom: 6px;
}
.literature-ul .list-type {
  position: absolute;
  left: 0;
  top: 8px;
  width: 8px;
  height: 8px;
  background: #484d63;
  mix-blend-mode: darken;
  border-radius: 50px;
}
.general-info-container dd a i.italic {
  font-style: italic;
}
.fossil-general-images {
  width: 100%;
}
.fossil-general-images ul li {
  margin-top: 12px;
}
.fossil-details-info .el-image__inner {
  width: 100% !important;
  height: 100% !important;
}
</style>
